import { useMutation } from "@tanstack/react-query";
import { updateSettings as apiEditSettings } from "../../api/apiSettings";
import toast from "react-hot-toast";
// import { useNavigate } from "react-router-dom";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUpdateSettings() {
    // const navigate = useNavigate();

    const {
        mutate: editSettings,
        isPending: isUpdate,
        data: results,
        error,
    } = useMutation({
        mutationFn: ({ req }) => apiEditSettings(req),
        onSuccess: (response) => {
            toast.success(response.message);
            // navigate('/settings');
        },
        onError: (err) => {
            console.error("Error:", err);
            const msg = getErrorMessageFromAxiosError(err, "Something Wont Wrong!");
            toast.error(msg);
        },

    });

    return { editSettings, isUpdate, error, results };
}
